import React from 'react';

const PrivacyPolicy = () => {
	return <div className="terms-and-policy">
		<div className="mb-20">
			<div>Last Updated March 2024.</div>
			<a style={{ color: '#0052cc' }} href='#kids-policy'>Kids Advertising Policy</a>
		</div>
		<div className="mb-10">
			<div>Channel Factory, LLC (“Channel Factory” or “we”)
			provides this Privacy Policy to inform you of our policies and procedures regarding the collection,
			use, protection, and disclosure of Personal Information received from your use of this website,
			located at <a href="https://www.channelfactory.com"
							target="_blank">www.channelfactory.com</a> (“Site”), as well as all related websites,
			applications,
			browser extensions, and other services provided by us (collectively, together with the Site, our
			“Service”), and in connection with our customer, vendor, and partner relationships. This Privacy
			Policy also tells you about your rights and choices with respect to your personal information, and
			how you can reach us to update your contact information or get answers to questions you may have
			about our privacy practices.
			</div>
		</div>
		<div className="mb-10">
			<div>This policy also tells you how we use tracking technologies, cookies, and browsing data we
				collect from your use of our Services, the measures we take to protect the security of the
				information you provide to us through our Services, and how you can contact us if you have any
				questions regarding our online services.
			</div>
		</div>
		<div className="mb-10">
			<div>By using our Services, you expressly consent to our collection, use, disclosure, and retention
				of your information relating to your use of the Services. Our goal is to collect and use
				information to deliver effective and personalized services, which take your interests and
				preferences into account, as well as for our legitimate business needs and interests.
			</div>
		</div>
		<div className="mb-10">
			<div>There are two main types of information we collect about users of our Services that include
				(but are not limited to) the following:
			</div>
		</div>
		<div className="mb-20">
			<div>
				<ol className="disc">
					<li>
						Information that identifies you: this is commonly referred to as “personal information”
						and includes, for example, information that you provide to us such as your name, email
						address, company and title if you ask for access to or demonstrations of any of our
						products; and
					</li>
					<li>
						Information that relates to you, but on its own does not identify you: such as
						information about your Internet connection, the equipment you use to access our
						Services, the type and version of your device's operating system or web browser, in some
						cases your device's location, and information relating to your usage of our Services.
					</li>
				</ol>
			</div>
		</div>
		<div className="mb-10">
			<div>The methods we use to collect information about you are as follows:</div>
		</div>
		<div className="mb-10">
			<div>
				Directly from you, when you provide it to us. For example, when you request products or services
				from us, when you register with us, respond to surveys, apply for a job, contact us or otherwise
				interact with us. Please remember that if others use devices into which you remain logged in,
				they may share information with us as if they were you, and they may have access to information
				that you have previously provided us. To protect your privacy, please log out from our online
				services that you access from public or shared devices.
			</div>
		</div>
		<div className="mb-10">
			<div>Automatically, when you use our Site: information collected through the use of cookies and
				other technologies. Like most web businesses, we use automated mechanisms (e.g., cookies and
				pixels) with unique identifiers to keep track of user interactions with our Services. We may use
				our own technology for that purpose, and we also may use third party services such as Google
				Analytics, in which case those third parties gather information such as your IP address, browser
				type, the webpage from which you came to our website, and the times of your access to our
				Services. In addition, as you browse Channel Factory.com and other Channel Factory URLs,
				advertising cookies may be placed on your computer so that we can understand what you are
				interested in.
			</div>
		</div>
		<div className="mb-10">
			<div>From influencer partners' YouTube channels. Channel Factory partners with social media
				influencers for various advertising campaigns. We extract the information of visitors to the
				social media channels and postings (e.g. API) of our influencer partners. This information is
				encrypted, secured and collected under YouTube's own privacy policy and terms of use.
			</div>
		</div>
		<div className="mb-10">
			<div>From our business customers/brand clients, who provide Channel Factory with their user data.
				User data provided to Channel Factory are typically encrypted by Google or the client prior to
				reaching Channel Factory. Channel Factory also hashes and/or encrypts use data provided to us by
				the client.
			</div>
		</div>
		<div className="mb-20">
			<div>From third parties, including social networks, other online services, publicly available
				records, our service providers. and from consumer data resellers.
			</div>
		</div>
		<div className="mb-10">
			<div className="title">HOW WE USE YOUR INFORMATION</div>
			<div>We (and our service providers) use information to:</div>
			<ol className="disc">
				<li>provide the online services you have requested;</li>
				<li>respond to your inquiries, requests, and comments;</li>
				<li>protect the safety of users and others on our Services;</li>
				<li>understand how our Services are used so that we can continuously improve them;</li>
				<li>send you newsletters and information about products, services and promotions relating to us
					and/or our business partners or other organizations that we work with, in accordance with
					your communication preferences; and
				</li>
				<li>send you service-related communications, including announcements and administrative messages.</li>
			</ol>
		</div>
		<div className="mb-10">
			<div className="title">HOW WE SHARE YOUR INFORMATION</div>
			<div>Service providers that we have retained to perform certain business-related functions on our
				behalf: for example, service providers who offer services including research and analytics;
				hosting websites, fulfilling transactions, maintaining databases, and providing technology
				services and platforms. These parties are provided only with the personal information or
				other information they need to perform their functions and can only use and disclose that
				information as is necessary to perform the services on our behalf, or to comply with legal
				requirements. We take steps to ensure that third party service providers will take appropriate
				steps to protect your personal information.
			</div>
		</div>
		<div className="mb-10">
			<div>Clients/customers: we provide analytics and tools to our customers and clients regarding the
				optimization of their advertising campaigns to certain demographics. This is a core and
				necessary component of our business. Personal identifying information is encrypted and
				protected.
			</div>
		</div>
		<div className="mb-10">
			<div>In addition, we may disclose your personal information to law enforcement agencies,
				government/regulatory bodies, and content protection organizations to:
			</div>
		</div>
		<div className="mb-20">
			<ol className="disc">
				<li>Protect our legal rights, privacy or safety, and that of our subsidiaries, affiliates,
					employees, agents, contractors, or other individuals;
				</li>
				<li>Protect the safety and security of visitors to our Site;</li>
				<li>Protect against fraud or other illegal activity or for risk management purposes;</li>
				<li>Respond to inquiries or requests from government, regulatory, law enforcement, or public
					authorities;</li>
				<li>Permit us to pursue available remedies, commence, participate in, or defend litigation, or
					limit the damages that we may sustain;</li>
				<li>Comply with the law including with subpoenas, search warrants, court orders, and other legal
					process; or</li>
				<li>Enforce applicable terms of service.</li>
			</ol>
		</div>
		<div className="mb-10">
			<div className="title">SALE OR TRANSFER OF ALL OR A PART OF OUR BUSINESS</div>
			<div>We reserve the right to transfer the information described in this Privacy Policy in the event
				we sell or transfer all or a part of our business or assets so that the buyer can continue to
				offer you the online services. We will make commercially reasonable efforts to provide you with
				reasonable notice of such transfer, or as otherwise required by law. If you do not want your
				personal information to be processed following such a transfer, you should contact the
				subsequent owner of the business.
			</div>
		</div>
		<div className="mb-10">
			<div className="title">HOW WE PROTECT YOUR INFORMATION</div>
			<div>We maintain procedural, technical, and physical safeguards for our online services to help
				protect against loss, misuse or unauthorized access, disclosure, alteration, or destruction of
				the personal information you provide via our Services. We also ask the service providers that
				help us deliver our services to do the same. For example, we limit access to this information to
				authorized employees and contractors who need to know that information in order to operate,
				develop, or improve our services. Unfortunately, no transmission of data is guaranteed to be
				completely secure. It may be possible for third parties not under our control to intercept or
				access transmissions or private communications unlawfully. Therefore, any transmission of
				personal information to us is made at your own risk. If you believe that your interaction with
				us is no longer secure, please notify us using the contact details below.
			</div>
		</div>
		<div className="mb-10">
			<div className="title">WHERE YOUR INFORMATION WILL BE USED</div>
			<div>Channel Factory is based in the United States and may from time to time transfer your personal
				information to other countries and make it accessible to any of our affiliates and third-party
				service providers internationally. Where the transfer of information is to a country that does
				not provide an adequate level of information protection, Channel Factory has taken steps to
				ensure that your personal information receives an appropriate level of protection.
			</div>
		</div>
		<div className="mb-10">
			<div>If you are located outside of the United States, please be aware that information we collect,
				including personal information, may be transferred to, and processed, stored and used in the
				United States. Under United States law, your personal information may be subject to access
				requests from governments, courts, or law enforcement in the United States. By using our Site
				and providing your personal information to us, you understand and agree that your personal
				information may be sent to other countries including those which do not provide an equivalent
				level of information protection as the European Economic Area (EEA).
			</div>
		</div>
		<div className="mb-10">
			<div className="title">DO NOT TRACK</div>
			<div>Channel Factory does not process or respond to web browsers' “do not track” signals or other
				similar transmissions that indicate a request to disable online tracking of users who use our
				Service.
			</div>
		</div>
		<div className="mb-10">
			<div className="title">THIRD PARTY WEB BEACONS AND THIRD PARTY BUTTONS</div>
			<div>We may display third-party content on the Service, including third-party advertising.
				Third-party content may use cookies, web beacons, or other mechanisms for obtaining data in
				connection with your viewing of the third party content on the Service. Additionally, we may
				implement third party buttons, such as Facebook “share” buttons, that may function as web
				beacons even when you do not interact with the button. Information collected through third-party
				web beacons and buttons is collected directly by these third parties, not by Channel Factory.
				Please consult such third party's data collection, use, and disclosure policies for more
				information.
			</div>
		</div>
		<div className="mb-10">
			<div className="title">LINKS TO OTHER WEBSITES</div>
			<div>Our Site contains links to other websites. The fact that we link to a website is not an
				endorsement, authorization or representation of our affiliation with that third party. We do not
				exercise control over third party websites. These other websites may place their own cookies or
				other files on your computer, collect data or solicit personal information from you. Other sites
				follow different rules regarding the use or disclosure of the personal information you submit to
				them. We are not responsible for the content, privacy and security practices, and policies of
				third-party sites or services to which links or access are provided through the Service. We
				encourage you to read the privacy policies or statements of the other websites you visit.
			</div>
		</div>
		<div className="mb-10">
			<a className="title" id='kids-policy' style={{ textDecoration: 'none', color: '#505050' }}>OUR POLICY TOWARDS KIDS ADVERTISING</a>
			<div>
				At Channel Factory, we take our responsibility to protect the privacy and safety of children very seriously.
				As such, we adhere to the Children's Online Privacy Protection Act (COPPA) to ensure that we provide a safe
				and secure online environment for children under the age of 13.
			</div>
			<div>
				It is our company policy that all partners working with Channel Factory must follow. Our policy includes
				the following guidelines:
			</div>
			<div className='pl-20'>
				<div>1. <a style={{ color: '#0052cc' }} target="_blank" href='https://support.google.com/youtube/answer/9528076?hl=en'>No targeted advertising to children under the age of 13:</a> We do not engage in targeted advertising to children under the age of 13. This includes using cookies or other technologies to track children's online behavior for the purpose of serving personalized ads.</div>
				<div>2. <a style={{ color: '#0052cc' }} target="_blank" href='https://support.google.com/youtube/answer/9713557'>Ad content must be appropriate for children:</a> Any ads that we serve to children must be appropriate for their age and development level. This means that we do not allow ads that are violent, sexual, or otherwise inappropriate for children.</div>
				<div>3. <a style={{ color: '#0052cc' }} target="_blank" href='https://support.google.com/adspolicy/answer/9683742?hl=en'>Clear and conspicuous disclosures:</a> Any ads that we serve to children must include clear and conspicuous disclosures that they are advertisements. This ensures that children can distinguish between ads and non-commercial content.</div>
				<div>4. <a style={{ color: '#0052cc' }} target="_blank" href='https://support.google.com/adspolicy/answer/9683742?hl=en'>Monitoring and enforcement:</a> We monitor both the advertising practices of ourselves and our partners to ensure compliance with our policies and COPPA's requirements. We also have a process in place for responding to any concerns or complaints related to our advertising practices.</div>
			</div>
			<div>
				By following these guidelines, we aim to provide a safe and secure online environment for children and to ensure that our advertising practices are ethical, responsible, and compliant with COPPA and other relevant regulations.
			</div>
		</div>
		<div className="mb-10">
			<div className="title">YOUR CALIFORNIA PRIVACY RIGHTS</div>
			<div>Residents of California have the right to request a disclosure describing what types of
				personal information we have shared with third parties for their direct marketing purposes, and
				with whom we have shared it, during the preceding year. You may request a copy of that
				disclosure by contacting us at <a
					href="mailto:contact@viewiq.com">contact@viewiq.com</a>.
			</div>
		</div>
		<div className="mb-10">
			<div className="title">UPDATES TO OUR PRIVACY POLICY</div>
			<div>From time to time, we may revise this Privacy Policy to reflect industry initiatives, changes
				in the law or technology, or changes in our practices regarding information collection and
				use. If we make material revisions to the way we collect or use your personal information
				so that we are using it for purposes or sharing data with third parties that you have not
				consented to, we will provide you with notice of those changes and may do so by either: (1)
				announcing the change on the home page of our Site or (2) taking other actions as we deem
				appropriate under the circumstances, including without limitation, posting the revised version
				of this Privacy Policy online. You agree that we may notify you about material changes in the
				way we treat personal information by placing a notice on our Site. You should check our Site
				frequently for updates. You can determine when this Privacy Policy was last revised by referring
				to the “Last Updated” or similar legend at the top of this page. Any changes to this Privacy
				Policy will become effective upon posting of the revised Privacy Policy on the Internet,
				accessible through this site. By continuing to use this online service following such changes,
				you will be deemed to have agreed to such changes. If you do not agree with the terms of this
				Privacy Policy, as it may be amended from time to time, in whole or in part, please do not
				continue to use our Site.
			</div>
		</div>
		<div className="mb-10">
			<div className="title">Contact Us</div>
			<div>For any queries or complaints in relation to this Privacy Policy or Channel Factory's privacy
				practices, please contact us at <a href="mailto:contact@viewiq.com">contact@viewiq.com</a> or <a href="tel:8666110694">866-611-0694</a>.
			</div>
		</div>
	</div>;
}

export default PrivacyPolicy;
